import styled from 'styled-components';
import Image from '../../UI/Image/Image';
import variables from '../../../styles/variables';

export const MessageWrapper = styled.div`
  background-color: ${variables.colorWhite};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-bottom: 52px;
  @media screen and (max-width: 1023px) {
    margin-bottom: 67px;
  }
`;

export const Container = styled.div`
  padding: 16px 10px 10px;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
`;

export const Heading = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`;
export const Logo = styled(Image)`
  margin-right: 7px;
`;

export const Content = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;
